module.exports = __webpack_public_path__ + "h5/img/clickT.eb2048c4.png";